// src/app/store/slices/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Permission } from '@core/constants/permissions';

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  roles: string[];
  roleTitles: string[];
  permissions: Permission[];
  loading: boolean;
}

const initialState: AuthState = {
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  roles: JSON.parse(localStorage.getItem('roles') || '[]'),
  roleTitles: JSON.parse(localStorage.getItem('roleTitles') || '[]'),
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
  loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        token: string;
        roles: string[];
        roleTitles?: string[];
        permissions: Permission[];
      }>
    ) => {
      state.token = action.payload.token;
      state.roles = action.payload.roles;
      state.roleTitles = action.payload.roleTitles ?? [];
      state.permissions = action.payload.permissions;
      state.isAuthenticated = true;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('roles', JSON.stringify(action.payload.roles));
      if (action.payload.roleTitles) {
        localStorage.setItem('roleTitles', JSON.stringify(action.payload.roleTitles));
      }
      localStorage.setItem('permissions', JSON.stringify(action.payload.permissions));
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.roles = [];
      state.roleTitles = [];
      state.permissions = [];
      localStorage.removeItem('token');
      localStorage.removeItem('roles');
      localStorage.removeItem('roleTitles');
      localStorage.removeItem('permissions');
      localStorage.removeItem('company');
      localStorage.removeItem('company_id');
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updatePermissions: (state, action: PayloadAction<Permission[]>) => {
      state.permissions = action.payload;
      localStorage.setItem('permissions', JSON.stringify(action.payload));
    },
  },
});

export const { setCredentials, logout, setLoading, updatePermissions } = authSlice.actions;

export default authSlice.reducer;

